import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import * as styles from './Modal.styles';

function ModalTitle(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ModalTitle'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className"]);

  if (!children) return null;
  var classes = cx(styles.ModalTitle, className);
  return /*#__PURE__*/React.createElement(View, Object.assign({}, otherProps, {
    className: classes,
    ref: forwardedRef
  }), children);
}

export default contextConnect(ModalTitle, 'ModalTitle');